module.exports = __webpack_public_path__ + "static/media/logo-cic.014c074f.jpg";